import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { WelletContext } from '@/context/wellet/welletContext';
import { formatPaymentMethod } from '@/helpers/format';
import { useDownloadPdfMutationNew } from '@/hooks/mutations/useDownloadPdfMutationNew';
import { getPaymentsMethods } from '@/services';
import { CardForm } from '@/uiComponents/common';
import SelectForm from '@/uiComponents/common/selects/selectNew';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

const CommissionCard = ({
  t,
  className,
  mode,
  showInfo,
  imageUrl,
  id,
  imgLoading,
  rolText,
}) => {
  const welletContext = useContext(WelletContext);
  const { t: translate } = useTranslation('translation', { keyPrefix: 'forms.userForm' });
  const { t: translatePayment } = useTranslation();

  const paymentsQuery = useQuery({
    queryKey: ['payments-methods'],
    queryFn: () => getPaymentsMethods(welletContext),
    refetchInterval: false,
    refetchOnWindowFocus: false,
    enabled: mode !== 'PROFILE',
  });

  const downloadPdfMutation = useDownloadPdfMutationNew(); // Instancia la mutación

  const printPDF = () => {
    downloadPdfMutation.mutate(id);
  };

  return (
    <>
      <CardForm
        title={t('comissionCard.title')}
        subtitle={t('comissionCard.subtitle')}
        className={className}
      >
        <div className='row tw-mb-6'>
          {showInfo && mode !== 'PROFILE' && (
            <SelectForm
              name={'withdrawalMethod'}
              label={t('paymentMethod.title')}
              className={'col-12 tw-mb-6'}
              placeholder={t('paymentMethod.placeholder')}
              options={paymentsQuery?.data?.data?.map((p) => ({
                label: formatPaymentMethod(p, translatePayment),
                value: p,
              }))}
            />
          )}
          {mode === 'CONCIERGE' && (
            <>
              {/* <div className='col-12 tw-mb-6'>
                <Label className='!tw-mb-3'>{t('rowCommissions.title')}</Label>
                <InputCheckboxForm
                  name={'isCommissionDisabled'}
                  label={translate('inputModernSwithcer.label')}
                />
              </div>

              <div className='col-12 tw-mb-6'>
                <InputNumberForm
                  name={'commissionPlusPercentage'}
                  className='mb-3'
                  currencySymbol={'%'}
                  label={translate('inputComissionsPercentage.label')}
                  maxNumber={100}
                  minNumber={0}
                  isDisabled={isCommissionDisabled}
                  placeholder={translate('inputComissionsPercentage.placeholder')}
                />
              </div> */}

              <div className='col-12'>
                <Label className='!tw-mb-3'>
                  {translate('linkQr.title', {
                    name: rolText,
                  })}
                </Label>
                {imageUrl && !imgLoading ? (
                  <div>
                    <img alt='' src={imageUrl} width='250px' height='250px' />
                    <Button
                      className={'mt-2 d-block'}
                      onClick={printPDF}
                      size={'sm'}
                      disabled={downloadPdfMutation.isLoading}
                      loading={downloadPdfMutation.isLoading}
                      type='button'
                    >
                      {translate('linkQr.download')}
                    </Button>
                  </div>
                ) : (
                  <p>{translate('linkQr.noLink')}</p>
                )}
              </div>
            </>
          )}
        </div>
      </CardForm>
    </>
  );
};

export default CommissionCard;
